export function getMaxHourlyBucketCount(occurrences) {
	const bucketCounts = new Map();

	const getHourKey = (date) => {
		const year = date.getUTCFullYear();
		const month = String(date.getUTCMonth() + 1).padStart(2, "0");
		const day = String(date.getUTCDate()).padStart(2, "0");
		const hour = String(date.getUTCHours()).padStart(2, "0");
		return `${year}-${month}-${day}_${hour}`;
	};

	occurrences?.forEach(({ startAt, endAt }) => {
		const start = new Date(startAt);
		const end = new Date(endAt);

		const current = new Date(start);
		current.setUTCMinutes(0, 0, 0);

		while (current < end) {
			const key = getHourKey(current);
			bucketCounts.set(key, (bucketCounts.get(key) || 0) + 1);
			current.setUTCHours(current.getUTCHours() + 1);
		}
	});

	return Math.max(0, ...bucketCounts.values());
}
